const Completed = () => {
    return <>
        <link rel="stylesheet" href="css/Completed.module.css" />
        <div className="mkd-content">
         {/*SLIDER START*/}
      <div className="mkd-ps-image-holder">
        <div className="mkd-ps-image mkd-owl-slider">
          <div className="mkd-ps-image">
            <picture>
              <source media="(min-width: 481px)" srcSet="assets/upcoming/banner.jpg" />
              <source media="(max-width: 480px)" srcSet="assets/upcoming/clover-mobile.jpg" />
              <img className="d-block w-100" src="assets/upcoming/clover-mobile.jpg" alt="Banner" loading="lazy" />
            </picture>
          </div>
        </div>
      </div>
      {/*SLIDER END*/}
     
            <div className="vc_empty_space" style={{ height: 40 }}>
                <span className="vc_empty_space_inner" />
            </div>
            {/*COMPLETED START*/}
            <div className="mkd-content">
                <div className="mkd-content-inner">
                    <section className="wpb-content-wrapper location-advantages">
                        <div className="mkd-row-grid-section-wrapper ">
                            <div className="mkd-row-grid-section">
                                <div className="vc_row wpb_row vc_row-fluid vc_custom_1516021087353">
                                    <div className="wpb_column vc_column_container vc_col-sm-12">
                                        <div className="vc_column-inner vc_custom_1516007647796">
                                            <div className="wpb_wrapper">
                                                <div className="mkd-elements-holder   mkd-one-column  mkd-responsive-mode-768 ">
                                                    <div
                                                        className="mkd-eh-item    "
                                                        data-item-class="mkd-eh-custom-8773"
                                                        data-1280-1600="0 0 20px 0"
                                                        data-1024-1280="0 0 20px 0"
                                                        data-768-1024="0 0 20px 0"
                                                        data-680-768="0 0 20px 0"
                                                        data-680="0px"
                                                    >
                                                        <div className="mkd-eh-item-inner">
                                                            <div
                                                                className="mkd-eh-item-content mkd-eh-custom-8773"
                                                                style={{ padding: "0 0 20px 0" }}
                                                            >
                                                                <div className="mkd-section-title-holder  ">
                                                                    <div className="mkd-st-inner road">
                                                                        <h2 className="mkd-st-title">
                                                                            Upcoming projects
                                                                        </h2>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div className="mkd-full-width">
                        <div className="mkd-full-width-inner">
                            <div className="mkd-grid-row">
                                <div className="mkd-page-content-holder mkd-grid-col-12">
                                    <section className="wpb-content-wrapper">
                                        <div className="mkd-row-grid-section-wrapper ">
                                            <div className="mkd-row-grid-section">
                                                <div className="vc_row wpb_row vc_row-fluid vc_custom_1517921876626">
                                                    <div className="wpb_column vc_column_container vc_col-sm-12">
                                                        <div className="vc_column-inner">
                                                            <div className="wpb_wrapper">

                                                                {/* Added custom spacing style */}
                                                                <style>
                                                                    {`
                                                .mkd-pl-inner {
                                                    display: flex;
                                                    gap: 100px; /* space between articles */
                                                    flex-wrap: wrap;
                                                    border-bottom: 2px solid #3f3f3f;
                                                    .mkd-pl-inner
                                                }
                                                `}
                                                                </style>

                                                                <div className="mkd-portfolio-list-holder mkd-pl-gallery mkd-normal-space mkd-pl-three-columns mkd-pl-standard-shader mkd-pl-pag-no-pagination">
                                                                    <div className="mkd-pl-inner mkd-outer-space clearfix">

                                                                        {/* Article 1 */}
                                                                        <article className="mkd-pl-item mkd-item-space post-1636 portfolio-item type-portfolio-item status-publish has-post-thumbnail hentry portfolio-category-visualization flipper-container">
                                                                            <div className="mkd-pl-item-inner flipper">
                                                                                <div className="mkd-pli-image flipper-front">
                                                                                    <img
                                                                                        width={550}
                                                                                        height={550}
                                                                                        src="assets/upcoming/upcoming.jpg"
                                                                                        className="attachment-entre_mikado_square size-entre_mikado_square wp-post-image"
                                                                                        alt="Newry Astor"
                                                                                    />
                                                                                </div>
                                                                                <div className="mkd-pli-text-holder flipper-back">
                                                                                    <div className="mkd-pli-text-wrapper">
                                                                                        <div className="mkd-pli-text">
                                                                                            <h4 className="mkd-pli-title entry-title">
                                                                                                COMING SOON - Residential
                                                                                            </h4>
                                                                                            <div className="mkd-pli-category-holder">
                                                                                                <p>
                                                                                                    <a className="mkd-pli-category">
                                                                                                        📍 Parivakkam
                                                                                                    </a>
                                                                                                </p>

                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </article>

                                                                        {/* Article 2 */}
                                                                        <article className="mkd-pl-item mkd-item-space post-1637 portfolio-item type-portfolio-item status-publish has-post-thumbnail hentry portfolio-category-visualization flipper-container">
                                                                            <div className="mkd-pl-item-inner flipper">
                                                                                <div className="mkd-pli-image flipper-front">
                                                                                    <img
                                                                                        width={550}
                                                                                        height={550}
                                                                                        src="assets/upcoming/amethyst.jpg"
                                                                                        className="attachment-entre_mikado_square size-entre_mikado_square wp-post-image"
                                                                                        alt="Newry Clover County"
                                                                                    />
                                                                                </div>
                                                                                <div className="mkd-pli-text-holder flipper-back">
                                                                                    <div className="mkd-pli-text-wrapper">
                                                                                        <div className="mkd-pli-text">
                                                                                            <h4 className="mkd-pli-title entry-title">
                                                                                                COMING SOON - PLOT
                                                                                            </h4>
                                                                                            <div className="mkd-pli-category-holder">
                                                                                                <p>
                                                                                                    <a className="mkd-pli-category">
                                                                                                        📍 Padappai
                                                                                                    </a>
                                                                                                </p>

                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </article>

                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {/*COMPLETED END*/}
        </div>

    </>;
};

export default Completed;